export const tr = {
    FROM_14_TO_28_DAYS: '14-28 gün',
    FROM_1_TO_3_DAYS: '1-3 gün',
    FROM_1_TO_3_MONTHS: '1 - 3 ay',
    FROM_3_TO_7_DAYS: '3-7 gün',
    FROM_7_TO_14_DAYS: '7-14 gün',
    MONTHLY: 'aylık',
    MORE_THAN_3_MONTHS: '3 aydan fazla'
};
